(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("45EB9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e64b30933aa960a$export$2e2bcd8739ae039; });

var $2hYdk = parcelRequire("2hYdk");

var $5ayqG = parcelRequire("5ayqG");

var $gDdCy = parcelRequire("gDdCy");
const $4e64b30933aa960a$var$dutchieIframeDataSource = ()=>{
    (0, $5ayqG.postMessageSource)((event)=>{
        var _rawData_payload;
        const rawData = (0, $gDdCy.tryParseJSONObject)(event.data);
        const payload = (rawData === null || rawData === void 0 ? void 0 : (_rawData_payload = rawData.payload) === null || _rawData_payload === void 0 ? void 0 : _rawData_payload.payload) || null;
        if (rawData.event === "analytics:dataLayer" && payload.event === "add_to_cart") {
            const products = payload.ecommerce.items;
            const { item_id: item_id, item_name: item_name, item_category: item_category, price: price, quantity: quantity } = products[0];
            (0, $2hYdk.default).notify({
                addToCartEvent: {
                    sku: item_id.toString(),
                    name: (item_name === null || item_name === void 0 ? void 0 : item_name.toString()) || "N/A",
                    category: (item_category === null || item_category === void 0 ? void 0 : item_category.toString()) || "N/A",
                    unitPrice: parseFloat(price || "0"),
                    quantity: parseInt(quantity || "1"),
                    currency: "USD"
                }
            });
        }
        if (rawData.event === "analytics:dataLayer" && payload.event === "remove_from_cart") {
            const products = payload.ecommerce.items;
            const { item_id: item_id, item_name: item_name, item_category: item_category, price: price, quantity: quantity } = products[0];
            (0, $2hYdk.default).notify({
                removeFromCartEvent: {
                    sku: item_id.toString(),
                    name: (item_name === null || item_name === void 0 ? void 0 : item_name.toString()) || "N/A",
                    category: (item_category === null || item_category === void 0 ? void 0 : item_category.toString()) || "N/A",
                    unitPrice: parseFloat(price || "0"),
                    quantity: parseInt(quantity || "1"),
                    currency: "USD"
                }
            });
        }
        if (rawData.event === "analytics:dataLayer" && rawData.payload.payload["1"] === "purchase") try {
            const transaction = rawData.payload.payload["2"];
            const products = transaction.items;
            const { transaction_id: transaction_id, value: value } = transaction;
            (0, $2hYdk.default).notify({
                transactionEvent: {
                    id: transaction_id.toString(),
                    total: parseFloat(value || 0),
                    tax: 0,
                    shipping: 0,
                    city: "N/A",
                    state: "N/A",
                    country: "N/A",
                    currency: "USD",
                    items: products.map((product)=>{
                        const { item_id: item_id, item_name: item_name, item_category: item_category, price: price, quantity: quantity } = product;
                        return {
                            orderId: transaction_id.toString(),
                            productId: item_id.toString(),
                            sku: item_id.toString(),
                            name: (item_name || "N/A").toString(),
                            category: (item_category || "N/A").toString(),
                            unitPrice: parseFloat(price || 0),
                            quantity: parseInt(quantity || 1),
                            currency: "USD"
                        };
                    })
                }
            });
        } catch (error) {
        // window.tracker("trackError", JSON.stringify(error), "DUTCHIEIFRAME");
        }
        if (rawData.event == "analytics:dataLayer" && payload.event == "purchase") try {
            const transaction = payload.ecommerce;
            const products = transaction.items;
            const { transaction_id: transaction_id, value: value } = transaction;
            (0, $2hYdk.default).notify({
                transactionEvent: {
                    id: transaction_id.toString(),
                    total: parseFloat(value || 0),
                    tax: 0,
                    shipping: 0,
                    city: "N/A",
                    state: "N/A",
                    country: "N/A",
                    currency: "USD",
                    items: products.map((product)=>{
                        const { item_id: item_id, item_name: item_name, item_category: item_category, price: price, quantity: quantity } = product;
                        return {
                            orderId: transaction_id.toString(),
                            productId: item_id.toString(),
                            sku: item_id.toString(),
                            name: (item_name || "N/A").toString(),
                            category: (item_category || "N/A").toString(),
                            unitPrice: parseFloat(price || 0),
                            quantity: parseInt(quantity || 1),
                            currency: "USD"
                        };
                    })
                }
            });
        } catch (error) {
        // window.tracker("trackError", JSON.stringify(error), "DUTCHIEIFRAME");
        }
    });
};
var $4e64b30933aa960a$export$2e2bcd8739ae039 = $4e64b30933aa960a$var$dutchieIframeDataSource;

});
parcelRegister("5ayqG", function(module, exports) {

$parcel$export(module.exports, "postMessageSource", function () { return $5b9746592ec0dabd$export$653284ea2e114aa2; });
const $5b9746592ec0dabd$export$653284ea2e114aa2 = (callback)=>{
    window.addEventListener("message", callback, false);
};

});

parcelRegister("gDdCy", function(module, exports) {

$parcel$export(module.exports, "tryParseJSONObject", function () { return $3314a60fcd51e41f$export$8b0f5bf83db88e; });

var $lwczO = parcelRequire("lwczO");
const $3314a60fcd51e41f$export$8b0f5bf83db88e = (event)=>{
    try {
        if (typeof event === "object") return event;
        if (typeof event === "string") return JSON.parse(event);
    } catch (e) {
        (0, $lwczO.default).error("Error parsing event:", e);
    }
    return event;
};

});


})();
//# sourceMappingURL=dutchie-iframe.c0befea1.js.map
